<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.66675 14.6667H12.0001C12.3537 14.6667 12.6928 14.5262 12.9429 14.2761C13.1929 14.0261 13.3334 13.687 13.3334 13.3333V4.66667L10.0001 1.33333H4.00008C3.64646 1.33333 3.30732 1.47381 3.05727 1.72386C2.80722 1.97391 2.66675 2.31305 2.66675 2.66667V5.33333M9.33341 1.33333V4C9.33341 4.35362 9.47389 4.69276 9.72394 4.94281C9.97399 5.19286 10.3131 5.33333 10.6667 5.33333H13.3334"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M-0.245361 12.6667V7.81818H1.66752C2.03526 7.81818 2.34855 7.88842 2.60739 8.02888C2.86622 8.16777 3.06351 8.36111 3.19924 8.6089C3.33655 8.85511 3.40521 9.1392 3.40521 9.46117C3.40521 9.78314 3.33576 10.0672 3.19687 10.3134C3.05798 10.5597 2.85675 10.7514 2.59318 10.8887C2.33119 11.026 2.01395 11.0947 1.64148 11.0947H0.422252V10.2732H1.47576C1.67304 10.2732 1.8356 10.2393 1.96345 10.1714C2.09286 10.102 2.18914 10.0065 2.25227 9.88494C2.31698 9.76184 2.34934 9.62058 2.34934 9.46117C2.34934 9.30019 2.31698 9.15972 2.25227 9.03977C2.18914 8.91825 2.09286 8.82434 1.96345 8.75805C1.83403 8.69018 1.66989 8.65625 1.47102 8.65625H0.779733V12.6667H-0.245361Z"
      fill="currentColor"
    />
    <path
      d="M5.78979 12.6667H4.07104V7.81818H5.804C6.29169 7.81818 6.71151 7.91525 7.06347 8.10938C7.41543 8.30193 7.6861 8.57891 7.8755 8.94034C8.06647 9.30177 8.16195 9.73422 8.16195 10.2377C8.16195 10.7427 8.06647 11.1768 7.8755 11.5398C7.6861 11.9028 7.41385 12.1813 7.05873 12.3755C6.7052 12.5696 6.28222 12.6667 5.78979 12.6667ZM5.09614 11.7884H5.74718C6.05021 11.7884 6.3051 11.7347 6.51186 11.6274C6.72019 11.5185 6.87644 11.3504 6.98061 11.1231C7.08635 10.8943 7.13923 10.5991 7.13923 10.2377C7.13923 9.87942 7.08635 9.58665 6.98061 9.35938C6.87644 9.1321 6.72098 8.9648 6.51423 8.85748C6.30747 8.75016 6.05258 8.6965 5.74955 8.6965H5.09614V11.7884Z"
      fill="currentColor"
    />
    <path
      d="M8.92131 12.6667V7.81818H12.1315V8.66335H9.9464V9.81866H11.9185V10.6638H9.9464V12.6667H8.92131Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts"></script>
